<template>
    <v-dialog v-model="visible" persistent max-width="640px">
        <v-card light>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span class="text-h5">Categorias de Vídeos</span>
                <v-spacer/>
            </v-card-title>

            <v-card-text>
                <!-- Formulário de cadastro/edição -->
                <v-row class="align-center">
                    <v-col cols="12" sm="6">
                        <v-text-field
                            label="Nome da categoria"
                            v-model="form.nome"
                            dense
                            outlined
                            hide-details
                            @keyup.enter="salvar"
                        />
                    </v-col>
                    <v-col cols="6" sm="3">
                        <v-text-field
                            label="Ordem"
                            v-model.number="form.ordem"
                            type="number"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="6" sm="3" class="d-flex">
                        <v-btn color="success" block @click="salvar" :loading="loadingSave">
                            <v-icon left small>{{ form.id ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                            {{ form.id ? 'Salvar' : 'Adicionar' }}
                        </v-btn>
                    </v-col>
                </v-row>
                <div v-if="form.id" class="text-right mb-2">
                    <v-btn x-small text color="grey" @click="resetForm">Cancelar edição</v-btn>
                </div>

                <v-divider class="my-2"/>

                <!-- Lista -->
                <div v-if="loading" class="text-center pa-4">
                    <v-progress-circular indeterminate color="primary" size="28"/>
                </div>
                <v-list v-else dense class="cat-list">
                    <v-list-item v-for="cat in categorias" :key="cat.id" class="px-2">
                        <v-list-item-avatar size="26" class="mr-2">
                            <v-chip x-small color="grey lighten-3">{{ cat.ordem }}</v-chip>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ cat.nome }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="flex-row align-center">
                            <v-chip
                                x-small
                                class="mr-2"
                                :color="cat.status === 'ativo' ? 'green lighten-4' : 'grey lighten-2'"
                                :text-color="cat.status === 'ativo' ? 'green darken-2' : 'grey darken-1'"
                            >
                                {{ cat.status === 'ativo' ? 'Ativo' : 'Inativo' }}
                            </v-chip>
                            <v-btn icon small @click="editar(cat)">
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon small color="error" @click="excluir(cat)">
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <div v-if="!categorias.length" class="text-center grey--text pa-4">
                        Nenhuma categoria cadastrada.
                    </div>
                </v-list>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn text color="primary" @click="$emit('close')">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CategoriasManager',

    props: {
        visible: { type: Boolean, default: false },
    },

    data: () => ({
        categorias: [],
        form: {},
        loading: false,
        loadingSave: false,
    }),

    watch: {
        visible(value) {
            if (value) {
                this.resetForm();
                this.consultar();
            }
        },
    },

    methods: {
        consultar() {
            this.loading = true;
            this.$http.get('categorias-video-ajuda').then(resp => {
                this.categorias = resp.data;
            }).catch(() => {
                alert('Não foi possivel carregar as categorias');
            }).finally(() => (this.loading = false));
        },

        resetForm() {
            const proximaOrdem = this.categorias.length
                ? Math.max(...this.categorias.map(c => Number(c.ordem) || 0)) + 1
                : 1;
            this.form = { status: 'ativo', ordem: proximaOrdem };
        },

        editar(cat) {
            this.form = JSON.parse(JSON.stringify(cat));
        },

        salvar() {
            if (!this.form.nome) {
                this.notify('Informe o nome da categoria', 'warning');
                return;
            }

            const id = this.form.id;
            const perm = id ? 'zapercontrol_videos_ajuda_atualizar' : 'zapercontrol_videos_ajuda_adicionar';
            if (!this.checkPermission(perm)) {
                alert('Usuário sem permissão');
                return;
            }

            this.loadingSave = true;
            const req = id
                ? this.$http.put(`categorias-video-ajuda/${id}`, this.form)
                : this.$http.post('categorias-video-ajuda', this.form);

            req.then(() => {
                this.consultar();
                this.resetForm();
                this.$emit('changed');
            }).catch(e => {
                alert(e);
            }).finally(() => (this.loadingSave = false));
        },

        async excluir(cat) {
            if (!this.checkPermission('zapercontrol_videos_ajuda_excluir')) {
                alert('Usuário sem permissão');
                return;
            }

            const ok = await this.$root.$confirm(
                'Excluir categoria',
                `Excluir "${cat.nome}"? Os vídeos vinculados ficarão sem categoria.`,
                { color: 'red darken-1' }
            );
            if (!ok) return;

            this.$http.delete(`categorias-video-ajuda/${cat.id}`).then(() => {
                this.notify('Categoria excluída!');
                this.consultar();
                this.$emit('changed');
            }).catch(() => {
                alert('Não foi possivel excluir a categoria');
            });
        },
    },
}
</script>

<style scoped>
.cat-list {
    max-height: 340px;
    overflow-y: auto;
}
</style>
